import React, { Component } from 'react'
import Magnifier from 'react-magnifier'

interface MagnifierProps {
    src: string
    id: string
    mgWidth: number
    mgHeight: number
    mgOverflow: boolean
}

type MagnifierTypes = {
    canZoom: boolean
    zoomFactor: number
}

class PortalMagnifier extends Component<MagnifierProps, MagnifierTypes>{

    constructor(props: MagnifierProps) {
        super(props)
        this.state = {
            canZoom: false,
            zoomFactor: .6

        }
    }

    componentDidMount() {
        document.addEventListener('wheel', this.handleMouseWheel)
    }

    componentWillUnmount() {
        document.removeEventListener('wheel', this.handleMouseWheel);
    }

    handleMouseWheel = (event: any) => {
        if (this.state.canZoom) {
            if (event.deltaY < 0 && this.state.zoomFactor < 2) {
                this.setState({ zoomFactor: this.state.zoomFactor + .2 })
            }
            if (event.deltaY > 0 && this.state.zoomFactor >= .8) {
                this.setState({ zoomFactor: this.state.zoomFactor - .2 })
            }
        }
    }

    toggleZoom = (args: string) => {
        if (args === "off") {
            this.setState({ canZoom: false })
        } else {
            this.setState({ canZoom: true })
        }
    }

    render() {
        let props = this.props
        return (
            <div id={this.props.id} onMouseEnter={() => this.toggleZoom("on")} onMouseLeave={() => this.toggleZoom("off")}>
                {/*!!r-18-bk*/}
                {/*@ts-ignore*/}
                <Magnifier src={props.src} height={"100%"} mgWidth={props.mgWidth} mgHeight={props.mgHeight} zoomFactor={this.state.zoomFactor} mgShowOverflow={props.mgOverflow} />
            </div>
        )
    }
}

export default PortalMagnifier